__turbopack_context__.v({
  "container": "b3aDKa_container",
  "cta": "b3aDKa_cta",
  "description": "b3aDKa_description",
  "imageContainer": "b3aDKa_imageContainer",
  "textContainer": "b3aDKa_textContainer",
});
